export default __webpack_public_path__ + "static/media/socleconnaissance.6ec8dc2a.jpg";